// UserList.js
import React, { useContext } from 'react';
import style from './UserListMini.module.css';

// Przykładowy obrazek (zastąp własnym)
import userOnline from 'assets/user_offline.svg'; 
import { useSocket } from 'context/SocketContext';
import DecodeToken from 'pages/Login/DecodeToken';
import { AppContext } from 'context/AppContext';


const OnlineIcon = ({status}) => {
  if(status=="Aktywny") {
  return( <span className={style.onlineIcon} title="Online" />);
};
}

// Przykładowe dane


/**
 * Komponent wyświetlający poziomą listę użytkowników.
 * Używa CSS Grid do elastycznego rozmieszczenia i dopasowania do szerokości rodzica.
 */
// const UserList = ({ usersIO = dummyUsers }) => {
const UserListMini = () => {
   const appcontext = useContext(AppContext);
      
      const pokazUzytkownikowOnline = appcontext.pokazUzytkownikowOnline;
      const setPokazUzytkownikowOnline = appcontext.setPokazUzytkownikowOnline;
   const { socket, isConnected, isAuthenticated, updateAuthStatus,usersIO } = useSocket()
  return (
    // Kontener główny, który zajmie 100% szerokości rodzica
    <div className={style.userListContainer}>
      {/* Używamy CSS Grid, aby umieścić użytkowników w jednym rzędzie 
          i automatycznie dopasować ich liczbę oraz rozmiar */}
      <div className={style.usersGrid}>
        {usersIO
          .filter(
            (user) =>
              // user.userId != DecodeToken(sessionStorage.getItem("token")).id
              user.userId !=10 && user.userId !=60
          )
          .map((user, i) => (
            // Pojedynczy element użytkownika
            <div
              title={`${user.imie} ${user.nazwisko}\nZalogowano: ${user.zalogowany}\nOstatnio aktywny: ${user.ostatnia_aktywnosc}\nSocket ID: ${user.socketId}`}
              key={user.socketId || i}
              className={
                user.status == "Aktywny" ? style.userCardActive : style.userCard
              }
            >
              <OnlineIcon status={user.status} />
              {/* Ikona użytkownika */}
              <img
                className={style.userIcon}
                src={user.imageUrl || userOnline} // Użyj obrazka z danych lub domyślnego
                alt={`Avatar użytkownika ${user.imie}`}
              />

              {/* Imię (skracane w CSS) */}
              <span className={style.userName}>{user.imie} </span>

              {/* Nazwisko (skracane w CSS) */}
              {/* <span className={style.userSurname}>{user.nazwisko}</span> */}
              <span className={style.userSurname}>{user.nazwisko}</span>

              {/* Data/czas zalogowania */}
              {/* {user.zalogowany && (
              <span className={style.loginTime}>
                Zalogowano: {user.zalogowany}
              </span>
            )} */}
            </div>
          ))}

        {/* {usersIO.length > 0 && DecodeToken(sessionStorage.getItem("token")).id== 1? (
          <div 
          onClick={()=>{setPokazUzytkownikowOnline(!pokazUzytkownikowOnline)}}
          title={`Użytkownicy zalogowani`} className={style.userCardInfo}>
          
            <span className={style.info}>{usersIO.length}</span>
          </div>
        ) : (
          <></>
        )} */}
      </div>
    </div>
  );
};

export default UserListMini;